import moment from "moment";
import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { FaCheckSquare } from "react-icons/fa";

const ReportTableTargetReport = ({ selectedData }) => {
  const [expandedRow, setExpandedRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10; // Ubah jumlah data per halaman sesuai kebutuhan

  const toggleExpand = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  // Hitung total halaman
  const totalPages = Math.ceil(
    selectedData?.target_report.length / rowsPerPage
  );

  // Ambil data berdasarkan halaman saat ini
  const currentData = selectedData?.target_report.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  return (
    <>
      <div className="table-responsive">
        <table className="table table-bordered table-custome">
          <thead>
            <tr className="text-white">
              <th className="text-center p-2">No</th>
              <th className="text-center p-2">Created</th>
              <th className="text-center p-2">Target</th>
              <th className="text-center p-2">Device</th>
              <th className="text-center p-2">Response Sentiment</th>
              <th className="text-center p-2">Follow Up</th>
              <th className="text-center p-2">Response Summary</th>
            </tr>
          </thead>
          <tbody>
            {currentData.length > 0 ? (
              currentData.map((row, index) => (
                <React.Fragment key={index}>
                  {/* Baris utama */}
                  <tr>
                    <td className="p-2">
                      {(currentPage - 1) * rowsPerPage + index + 1}
                    </td>
                    <td className="p-2">
                      {moment(row.ts_sent)
                        .format("DD-MM-YYYY | hh:mm A")
                        .replace("12 AM", "00 AM")}
                    </td>
                    <td className="p-2">{row.target}</td>
                    <td className="p-2 text-center">
                      {row.device ? row.device.name : "-"}
                    </td>
                    <td className="p-2 text-center">
                      {row.sentiment ? (
                        row.sentiment.toLowerCase() === "positive" ? (
                          <span class="badge bg-success py-1 px-2">
                            Positive
                          </span>
                        ) : row.sentiment.toLowerCase() === "negative" ? (
                          <span class="badge bg-danger py-1 px-2">
                            Negative
                          </span>
                        ) : row.sentiment.toLowerCase() === "neutral" ? (
                          <span class="badge bg-primary py-1 px-2">
                            Neutral
                          </span>
                        ) : row.sentiment.toLowerCase() === "no_response" ? (
                          <span class="badge bg-light text-dark py-1 px-2">
                            No Response
                          </span>
                        ) : null
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="p-2 text-center">
                      {row.need_follow_up === "Y" ? (
                        <FaCheckSquare size={16} style={{ color: "#e5a54b" }} />
                      ) : (
                        "-"
                      )}
                    </td>
                    <td className="p-2 text-center">
                      <button
                        className="btn btn-info btn-sm rounded"
                        onClick={() => toggleExpand(index)}
                      >
                        {expandedRow === index
                          ? "Hide Response Summary"
                          : "Show Response Summary"}
                      </button>
                    </td>
                  </tr>

                  {/* Baris tambahan untuk summary */}
                  {expandedRow === index && (
                    <tr>
                      <td colSpan="7" className="p-2 bg-light">
                        {row.response_summary || "No summary available"}
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center p-2">
                  No Data
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* Pagination */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-between">
          <div>
            Page {currentPage} of {totalPages}
          </div>
          <div>
            <Button
              variant="primary"
              className="btn btn-sm me-2"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            >
              Prev
            </Button>
            <Button
              variant="primary"
              className="btn btn-sm"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
            >
              Next
            </Button>
          </div>
        </div>
      )}
    </>
  );
};

export default ReportTableTargetReport;
